export default "__VITE_ASSET__CnjQp7JW__";